import { useEffect } from 'react';
const root = 'root';
export const useFocusTrapping = (ref) => {
    useEffect(() => {
        if (ref.current) {
            const modalElement = ref.current;
            const focusableElements = modalElement.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            const firstElement = focusableElements[0];
            firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus();
            const setInert = () => {
                const groundDivChildren = document.querySelectorAll(`#${root}>div:not(.toaster)`);
                for (const div of groundDivChildren) {
                    div.toggleAttribute('inert', true);
                }
                const dialogs = document.querySelectorAll('div[role="dialog"]:not([hidden]):not([aria-hidden])');
                for (const dialog of dialogs) {
                    if (dialog !== modalElement) {
                        dialog.toggleAttribute('inert', true);
                    }
                }
                const iframes = document.querySelectorAll('body>iframe');
                for (const iframe of iframes) {
                    iframe.toggleAttribute('inert', true);
                }
            };
            const removeInert = () => {
                const dialogs = document.querySelectorAll('div[role="dialog"]:not([hidden]):not([aria-hidden])');
                if (dialogs.length > 0) {
                    dialogs[dialogs.length - 1].toggleAttribute('inert', false);
                }
                else {
                    const groundDivChildren = document.querySelectorAll(`#${root}>div:not(.toaster)`);
                    for (const div of groundDivChildren) {
                        div.toggleAttribute('inert', false);
                    }
                    const iframes = document.querySelectorAll('body>iframe');
                    for (const iframe of iframes) {
                        iframe.toggleAttribute('inert', false);
                    }
                }
            };
            setInert();
            return () => {
                removeInert();
            };
        }
    }, [ref]);
};
